import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';
import fullscreenSVG from '../../ui/icons/fullscreen.svg';
import exitFullscreenSVG from '../../ui/icons/exit-fullscreen.svg';

const FullscreenToggle = VideoJS.getComponent('FullscreenToggle');

class ASFullscreenToggle extends FullscreenToggle {
    createEl() {
        const el =  super.createEl(...arguments);

        el.appendChild(VideoJS.dom.createEl('span', {
            innerHTML: fullscreenSVG,
            className: 'vjs-icon vjs-icon--fullscreen',
        }, {
            'aria-hidden': 'true'
        }));

        el.appendChild(VideoJS.dom.createEl('span', {
            innerHTML: exitFullscreenSVG,
            className: 'vjs-icon vjs-icon--exit-fullscreen',
        }, {
            'aria-hidden': 'true'
        }));

        return el;
    }

    buildCSSClass() {
        return `as-fullscreen-control ${super.buildCSSClass()}`;
    }
}

VideoJS.registerComponent(Controls.FULLSCREEN_TOGGLE, ASFullscreenToggle);

export default ASFullscreenToggle;



// WEBPACK FOOTER //
// ./src/player/components/ASFullscreenToggle.js